import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import { NO_MEDIA_TYPE } from 'constants/misc.const'; // eslint-disable-line no-unused-vars
import { AUTH_API } from 'middleware/api';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';
import { isNotValidId } from 'utils/predicates/fields.util';

export const PATCH_STYLIST_BIO_REQUEST = 'PATCH_STYLIST_BIO_REQUEST';
export const PATCH_STYLIST_BIO_SUCCESS = 'PATCH_STYLIST_BIO_SUCCESS';
export const PATCH_STYLIST_BIO_FAILURE = 'PATCH_STYLIST_BIO_FAILURE';

export const bePatchStylistBio = (options) => {
  const stylistId = isNotValidId(options?.stylistId)
    ? `invalid-stylist-id-${String(options?.stylistId)}`
    : options?.stylistId;

  const body = new FormData();

  if (options?.profile_image instanceof File) {
    body.append('profile_image', options?.profile_image);
  } else if (options?.profile_image === null) {
    // empty field for remove image
    body.append('profile_image', '');
  }
  const bio = fromAnyToString(options?.bio);
  // NOTE: There is no condition here - we always send it, even if it's false, otherwise it can't be toggled in the UI.
  body.append('bio', bio);

  const showImage = fromAnyToBool(options?.show_profile_image_in_ncob);
  // NOTE: There is no condition here - we always send it, even if it's false, otherwise it can't be toggled in the UI.
  body.append('show_profile_image_in_ncob', String(showImage));

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      authenticated: true,
      config: { method: H.patch, body, headers: { 'Content-Type': NO_MEDIA_TYPE } },
      endpoint: `salon/v3/:salonId/stylist/bio/${stylistId}/`,
      types: [PATCH_STYLIST_BIO_REQUEST, PATCH_STYLIST_BIO_SUCCESS, PATCH_STYLIST_BIO_FAILURE],
    },
  };
};

const fromDtoToStylistBio = (dto) => ({
  profileImage: dto?.results?.profile_image,
  showProfileImageInNcob: dto?.results?.show_profile_image_in_ncob,
  bio: dto?.results?.bio,
  id: dto?.results?.id,
});

const fromStylistBioToDto = (item) => ({
  profile_image: item?.profileImage,
  show_profile_image_in_ncob: item?.showProfileImageInNcob,
  bio: item?.bio,
  id: item?.id,
});

//

export const ibeStylistBioRead = actionEndpointBe(
  'ibeStylistBioRead',
  H.get,
  'salon/v3/:salonId/stylist/bio/:stylistId/',
  (options, extra) => ({
    ...options,
    inert: true,
    params: { stylistId: fromAnyToTrimmed(extra?.stylistId) || 0 },
    fromDto: fromDtoToStylistBio,
  }),
);

export const ibeStylistBioWrite = actionEndpointBe(
  'ibeStylistBioWrite',
  H.patch,
  'salon/v3/:salonId/stylist/bio/:stylistId/',
  (options, extra) => ({
    ...options,
    inert: true,
    fromDto: fromDtoToStylistBio,
    toDto: fromStylistBioToDto,
    data: extra?.data,
    params: { stylistId: fromAnyToTrimmed(extra?.stylistId) || 0 },
  }),
);
